export const Subtitle = ({
  children,
  className = '',
}: {
  children: string | React.ReactNode
  className?: string
}) => (
  <>
    <div className='d-none d-md-block'>
      <p
        className={`mc-text-large mc-text-color--tint mc-text--balance ${className}`}
      >
        {children}
      </p>
    </div>
    <div className='d-block d-md-none'>
      <p
        className={`mc-text-small mc-text-color--tint mc-text--balance ${className}`}
      >
        {children}
      </p>
    </div>
  </>
)
